// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2XHGv","headerWrap":"_2u2OP","heading":"_3dKi7","outer":"_3bPYs","iframeStyle":"Y_idu"};